<template>
  <div class="flex items-center">
    <slot />
    <NText
      v-if="isRetail(isin)"
      variant="overline"
      class="ms-1 text-neutral-secondary text-center flex-shrink-0"
      data-testid="retail-text"
    >
      {{ `(${t('symbol.retail')})` }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { isRetail } from '@core/symbol';

defineProps({
  isin: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();
</script>
